/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsPerDayDto } from '../../models/submissions-per-day-dto';

export interface DashboardSubmissionsPerDayGet$Plain$Params {
  fromDate?: string;
  toDate?: string;
}

export function dashboardSubmissionsPerDayGet$Plain(http: HttpClient, rootUrl: string, params?: DashboardSubmissionsPerDayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsPerDayDto>>> {
  const rb = new RequestBuilder(rootUrl, dashboardSubmissionsPerDayGet$Plain.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsPerDayDto>>;
    })
  );
}

dashboardSubmissionsPerDayGet$Plain.PATH = '/Dashboard/submissions-per-day';
